import * as nodemailer from "nodemailer";
import { S as SMTP_FROM, b as SMTP_USER, c as SMTP_HOST, d as SMTP_PORT, e as SMTP_PASSWORD } from "./private.js";
import { P as PUBLIC_ICON_URL } from "./public.js";
const emailVerificationTemplate = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN"\r
	"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">\r
<html lang="en" xmlns="http://www.w3.org/1999/xhtml">\r
<head>\r
	<meta charset="UTF-8">\r
	<meta content="width=device-width, initial-scale=1" name="viewport">\r
	<meta name="x-apple-disable-message-reformatting">\r
	<meta content="IE=edge" http-equiv="X-UA-Compatible">\r
	<meta content="telephone=no" name="format-detection">\r
	<title>New message</title><!--[if (mso 16)]>\r
	<style type="text/css">\r
		a {\r
			text-decoration: none;\r
		}\r
	</style>\r
	<![endif]--><!--[if gte mso 9]>\r
	<style>sup {\r
		font-size: 100% !important;\r
	}</style><![endif]--><!--[if gte mso 9]>\r
	<xml>\r
		<o:OfficeDocumentSettings>\r
			<o:AllowPNG></o:AllowPNG>\r
			<o:PixelsPerInch>96</o:PixelsPerInch>\r
		</o:OfficeDocumentSettings>\r
	</xml>\r
	<![endif]--><!--[if !mso]>-->\r
	<link href="https://fonts.googleapis.com/css?family=Roboto:400,400i,700,700i" rel="stylesheet"><!--<![endif]-->\r
	<style type="text/css">\r
        .rollover:hover .rollover-first {\r
            max-height: 0 !important;\r
            display: none !important;\r
        }\r
\r
        .rollover:hover .rollover-second {\r
            max-height: none !important;\r
            display: inline-block !important;\r
        }\r
\r
        .rollover div {\r
            font-size: 0px;\r
        }\r
\r
        u ~ div img + div > div {\r
            display: none;\r
        }\r
\r
        #outlook a {\r
            padding: 0;\r
        }\r
\r
        span.MsoHyperlink,\r
        span.MsoHyperlinkFollowed {\r
            color: inherit;\r
            mso-style-priority: 99;\r
        }\r
\r
        a.es-button {\r
            mso-style-priority: 100 !important;\r
            text-decoration: none !important;\r
        }\r
\r
        a[x-apple-data-detectors] {\r
            color: inherit !important;\r
            text-decoration: none !important;\r
            font-size: inherit !important;\r
            font-family: inherit !important;\r
            font-weight: inherit !important;\r
            line-height: inherit !important;\r
        }\r
\r
        .es-desk-hidden {\r
            display: none;\r
            float: left;\r
            overflow: hidden;\r
            width: 0;\r
            max-height: 0;\r
            line-height: 0;\r
            mso-hide: all;\r
        }\r
\r
        /*\r
	  .es-header-body a:hover {\r
		color:#2cb543!important;\r
		}\r
	  */\r
        /*\r
	  .es-content-body a:hover {\r
		color:#2cb543!important;\r
		}\r
	  */\r
        /*\r
	  .es-footer-body a:hover {\r
		color:#ffffff!important;\r
		}\r
	  */\r
        /*\r
	  .es-infoblock a:hover {\r
		color:#cccccc!important;\r
		}\r
	  */\r
        .es-button-border:hover {\r
            border-color: #42d159 #42d159 #42d159 #42d159 !important;\r
            background: #56d66b !important;\r
        }\r
\r
        .es-button-border:hover a.es-button,\r
        .es-button-border:hover button.es-button {\r
            background: #56d66b !important;\r
        }\r
\r
        @media only screen and (max-width: 600px) {\r
            .es-m-p35r {\r
                padding-right: 35px !important\r
            }\r
\r
            .es-m-p35l {\r
                padding-left: 35px !important\r
            }\r
\r
            *[class="gmail-fix"] {\r
                display: none !important\r
            }\r
\r
            p, a {\r
                line-height: 150% !important\r
            }\r
\r
            h1, h1 a {\r
                line-height: 120% !important\r
            }\r
\r
            h2, h2 a {\r
                line-height: 120% !important\r
            }\r
\r
            h3, h3 a {\r
                line-height: 120% !important\r
            }\r
\r
            h4, h4 a {\r
                line-height: 120% !important\r
            }\r
\r
            h5, h5 a {\r
                line-height: 120% !important\r
            }\r
\r
            h6, h6 a {\r
                line-height: 120% !important\r
            }\r
\r
            .es-header-body p {\r
            }\r
\r
            .es-content-body p {\r
            }\r
\r
            .es-footer-body p {\r
            }\r
\r
            .es-infoblock p {\r
            }\r
\r
            h1 {\r
                font-size: 30px !important;\r
                text-align: left\r
            }\r
\r
            h2 {\r
                font-size: 24px !important;\r
                text-align: left\r
            }\r
\r
            h3 {\r
                font-size: 20px !important;\r
                text-align: left\r
            }\r
\r
            h4 {\r
                font-size: 24px !important;\r
                text-align: left\r
            }\r
\r
            h5 {\r
                font-size: 20px !important;\r
                text-align: left\r
            }\r
\r
            h6 {\r
                font-size: 16px !important;\r
                text-align: left\r
            }\r
\r
            .es-header-body h1 a, .es-content-body h1 a, .es-footer-body h1 a {\r
                font-size: 30px !important\r
            }\r
\r
            .es-header-body h2 a, .es-content-body h2 a, .es-footer-body h2 a {\r
                font-size: 24px !important\r
            }\r
\r
            .es-header-body h3 a, .es-content-body h3 a, .es-footer-body h3 a {\r
                font-size: 20px !important\r
            }\r
\r
            .es-header-body h4 a, .es-content-body h4 a, .es-footer-body h4 a {\r
                font-size: 24px !important\r
            }\r
\r
            .es-header-body h5 a, .es-content-body h5 a, .es-footer-body h5 a {\r
                font-size: 20px !important\r
            }\r
\r
            .es-header-body h6 a, .es-content-body h6 a, .es-footer-body h6 a {\r
                font-size: 16px !important\r
            }\r
\r
            .es-menu td a {\r
                font-size: 14px !important\r
            }\r
\r
            .es-header-body p, .es-header-body a {\r
                font-size: 14px !important\r
            }\r
\r
            .es-content-body p, .es-content-body a {\r
                font-size: 14px !important\r
            }\r
\r
            .es-footer-body p, .es-footer-body a {\r
                font-size: 14px !important\r
            }\r
\r
            .es-infoblock p, .es-infoblock a {\r
                font-size: 12px !important\r
            }\r
\r
            .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3, .es-m-txt-c h4, .es-m-txt-c h5, .es-m-txt-c h6 {\r
                text-align: center !important\r
            }\r
\r
            .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3, .es-m-txt-r h4, .es-m-txt-r h5, .es-m-txt-r h6 {\r
                text-align: right !important\r
            }\r
\r
            .es-m-txt-j, .es-m-txt-j h1, .es-m-txt-j h2, .es-m-txt-j h3, .es-m-txt-j h4, .es-m-txt-j h5, .es-m-txt-j h6 {\r
                text-align: justify !important\r
            }\r
\r
            .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3, .es-m-txt-l h4, .es-m-txt-l h5, .es-m-txt-l h6 {\r
                text-align: left !important\r
            }\r
\r
            .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img, .es-m-txt-r .rollover:hover .rollover-second, .es-m-txt-c .rollover:hover .rollover-second, .es-m-txt-l .rollover:hover .rollover-second {\r
                display: inline !important\r
            }\r
\r
            .es-m-txt-r .rollover div, .es-m-txt-c .rollover div, .es-m-txt-l .rollover div {\r
                line-height: 0 !important;\r
                font-size: 0 !important\r
            }\r
\r
            .es-spacer {\r
                display: inline-table\r
            }\r
\r
            a.es-button, button.es-button {\r
                font-size: 18px !important\r
            }\r
\r
            .es-m-fw, .es-m-fw.es-fw, .es-m-fw .es-button {\r
                display: block !important\r
            }\r
\r
            .es-m-il, .es-m-il .es-button, .es-social, .es-social td, .es-menu {\r
                display: inline-block !important\r
            }\r
\r
            .es-adaptive table, .es-left, .es-right {\r
                width: 100% !important\r
            }\r
\r
            .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header {\r
                width: 100% !important;\r
                max-width: 600px !important\r
            }\r
\r
            .adapt-img:not([src*="default-img"]) {\r
                width: 100% !important;\r
                height: auto !important\r
            }\r
\r
            .es-mobile-hidden, .es-hidden {\r
                display: none !important\r
            }\r
\r
            .es-desk-hidden {\r
                width: auto !important;\r
                overflow: visible !important;\r
                float: none !important;\r
                max-height: inherit !important;\r
                line-height: inherit !important\r
            }\r
\r
            tr.es-desk-hidden {\r
                display: table-row !important\r
            }\r
\r
            table.es-desk-hidden {\r
                display: table !important\r
            }\r
\r
            td.es-desk-menu-hidden {\r
                display: table-cell !important\r
            }\r
\r
            .es-menu td {\r
                width: 1% !important\r
            }\r
\r
            table.es-table-not-adapt, .esd-block-html table {\r
                width: auto !important\r
            }\r
\r
            .es-social td {\r
                padding-bottom: 10px\r
            }\r
\r
            .es-text-3309, .es-text-3309 p, .es-text-3309 a, .es-text-3309 h1, .es-text-3309 h2, .es-text-3309 h3, .es-text-3309 h4, .es-text-3309 h5, .es-text-3309 h6, .es-text-3309 ul, .es-text-3309 ol {\r
                font-size: 20px !important\r
            }\r
\r
            a.es-button, button.es-button {\r
                display: inline-block !important\r
            }\r
\r
            .es-button-border {\r
                display: inline-block !important\r
            }\r
        }\r
	</style>\r
</head>\r
<body style="width:100%;height:100%;padding:0;Margin:0">\r
<div class="es-wrapper-color" style="background-color:#FFFFFF"><!--[if gte mso 9]>\r
	<v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">\r
		<v:fill type="tile" color="#FFFFFF"></v:fill>\r
	</v:background>\r
	<![endif]-->\r
	<table cellpadding="0" cellspacing="0" class="es-wrapper"\r
		   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top;background-color:#FFFFFF"\r
		   width="100%">\r
		<tr>\r
			<td style="padding:0;Margin:0" valign="top">\r
				<table align="center" cellpadding="0" cellspacing="0" class="es-content"\r
					   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:100%;table-layout:fixed !important">\r
					<tr>\r
						<td align="center" bgcolor="transparent" style="padding:0;Margin:0">\r
							<table align="center" bgcolor="#ffffff" cellpadding="0" cellspacing="0"\r
								   class="es-content-body"\r
								   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">\r
								<tr>\r
									<td align="left"\r
										style="padding:0;Margin:0;padding-top:20px;padding-right:20px;padding-left:20px">\r
										<table cellpadding="0" cellspacing="0"\r
											   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">\r
											<tr>\r
												<td align="left" style="padding:0;Margin:0;width:560px">\r
													<table cellpadding="0" cellspacing="0" role="presentation"\r
														   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"\r
														   width="100%">\r
														<tr>\r
															<td align="center"\r
																style="padding:0;Margin:0;padding-top:5px;padding-bottom:10px;font-size:0">\r
																<img\r
																	alt=""\r
																	src="https://glimmr.app/images/icon.png"\r
																	style="display:block;font-size:14px;border:0;outline:none;text-decoration:none;border-radius:50px"\r
																	width="100">\r
															</td>\r
														</tr>\r
														<tr>\r
															<td align="center"\r
																style="padding:20px;Margin:0;font-size:0">\r
																<table border="0" cellpadding="0" cellspacing="0"\r
																	   class="es-spacer" height="100%"\r
																	   role="presentation"\r
																	   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"\r
																	   width="100%">\r
																	<tr>\r
																		<td\r
																			style="padding:0;Margin:0;border-bottom:1px solid #cccccc;background:none;height:1px;width:100%;margin:0px"></td>\r
																	</tr>\r
																</table>\r
															</td>\r
														</tr>\r
													</table>\r
												</td>\r
											</tr>\r
										</table>\r
									</td>\r
								</tr>\r
							</table>\r
						</td>\r
					</tr>\r
				</table>\r
				<table align="center" cellpadding="0" cellspacing="0" class="es-content"\r
					   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:100%;table-layout:fixed !important">\r
					<tr>\r
						<td align="center" bgcolor="transparent" style="padding:0;Margin:0">\r
							<table align="center" bgcolor="#ffffff" cellpadding="0" cellspacing="0"\r
								   class="es-content-body"\r
								   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">\r
								<tr>\r
									<td align="left"\r
										style="padding:0;Margin:0;padding-top:20px;padding-right:20px;padding-left:20px">\r
										<table cellpadding="0" cellspacing="0"\r
											   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">\r
											<tr>\r
												<td align="left" style="padding:0;Margin:0;width:560px">\r
													<table cellpadding="0" cellspacing="0" role="presentation"\r
														   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"\r
														   width="100%">\r
														<tr>\r
															<td align="center" class="es-m-txt-c"\r
																style="padding:0;Margin:0"><h2\r
																style="Margin:0;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;mso-line-height-rule:exactly;letter-spacing:0;font-size:24px;font-style:normal;font-weight:normal;line-height:29px;color:#333333">\r
																<strong>Verify Your Email</strong></h2></td>\r
														</tr>\r
													</table>\r
												</td>\r
											</tr>\r
											<tr>\r
												<td align="left" style="padding:0;Margin:0;width:560px">\r
													<table cellpadding="0" cellspacing="0" role="presentation"\r
														   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"\r
														   width="100%">\r
														<tr>\r
															<td align="center" class="es-text-3309 es-m-txt-c"\r
																style="padding:0;Margin:0;padding-top:5px;font-size:20px">\r
																<p\r
																	style="Margin:0;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:34px !important;letter-spacing:0;color:#666666;font-size:20px">\r
																	Hi there,</p>\r
																<p\r
																	style="Margin:0;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:34px !important;letter-spacing:0;color:#666666;font-size:20px">\r
																	This is your one time verification code.</p></td>\r
														</tr>\r
													</table>\r
												</td>\r
											</tr>\r
										</table>\r
									</td>\r
								</tr>\r
							</table>\r
						</td>\r
					</tr>\r
				</table>\r
				<table align="center" cellpadding="0" cellspacing="0" class="es-content"\r
					   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:100%;table-layout:fixed !important">\r
					<tr>\r
						<td align="center" bgcolor="transparent" style="padding:0;Margin:0">\r
							<table align="center" bgcolor="#ffffff" cellpadding="0" cellspacing="0"\r
								   class="es-content-body"\r
								   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">\r
								<tr>\r
									<td align="left"\r
										style="padding:0;Margin:0;padding-top:20px;padding-right:20px;padding-left:20px">\r
										<table align="right" cellpadding="0" cellspacing="0" class="es-right"\r
											   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right">\r
											<tr>\r
												<td align="left" style="padding:0;Margin:0;width:560px">\r
													<table cellpadding="0" cellspacing="0" role="presentation"\r
														   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"\r
														   width="100%">\r
														<tr>\r
															<td align="center" bgcolor="#91f3fe"\r
																class="es-m-p35l es-m-p35r es-m-txt-c"\r
																style="Margin:0;padding-top:25px;padding-right:30px;padding-bottom:25px;padding-left:30px;border-radius:1rem;">\r
																<h1\r
																	style="Margin:0;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;mso-line-height-rule:exactly;letter-spacing:0;font-size:30px;font-style:normal;font-weight:normal;line-height:30px !important;color:#123533">\r
																	<strong>[CODE]</strong></h1></td>\r
														</tr>\r
														<tr>\r
															<td align="center"\r
																style="Margin:0;padding-right:20px;padding-left:20px;padding-top:35px;padding-bottom:20px;font-size:0">\r
																<table border="0" cellpadding="0" cellspacing="0"\r
																	   class="es-spacer" height="100%"\r
																	   role="presentation"\r
																	   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"\r
																	   width="100%">\r
																	<tr>\r
																		<td\r
																			style="padding:0;Margin:0;border-bottom:1px solid #cccccc;background:none;height:1px;width:100%;margin:0px"></td>\r
																	</tr>\r
																</table>\r
															</td>\r
														</tr>\r
													</table>\r
												</td>\r
											</tr>\r
										</table>\r
									</td>\r
								</tr>\r
							</table>\r
						</td>\r
					</tr>\r
				</table>\r
				<table align="center" cellpadding="0" cellspacing="0" class="es-content"\r
					   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:100%;table-layout:fixed !important">\r
					<tr>\r
						<td align="center" bgcolor="transparent" style="padding:0;Margin:0">\r
							<table align="center" bgcolor="#ffffff" cellpadding="0" cellspacing="0"\r
								   class="es-content-body"\r
								   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">\r
								<tr>\r
									<td align="left"\r
										style="padding:0;Margin:0;padding-top:20px;padding-right:20px;padding-left:20px">\r
										<table cellpadding="0" cellspacing="0"\r
											   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">\r
											<tr>\r
												<td align="left" style="padding:0;Margin:0;width:560px">\r
													<table cellpadding="0" cellspacing="0" role="presentation"\r
														   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"\r
														   width="100%">\r
														<tr>\r
															<td align="center" class="es-m-txt-c"\r
																style="padding:0;Margin:0"><p\r
																style="Margin:0;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;letter-spacing:0;color:#333333;font-size:14px">\r
																Questions? Email us at <a\r
																href="mailto:support@glimmr.app"\r
																style="mso-line-height-rule:exactly;text-decoration:underline;color:#19bcc2;font-size:14px">support@glimmr.app</a>\r
															</p></td>\r
														</tr>\r
													</table>\r
												</td>\r
											</tr>\r
										</table>\r
									</td>\r
								</tr>\r
							</table>\r
						</td>\r
					</tr>\r
				</table>\r
				<table align="center" cellpadding="0" cellspacing="0" class="es-content"\r
					   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:100%;table-layout:fixed !important">\r
					<tr>\r
						<td align="center" bgcolor="transparent" style="padding:0;Margin:0">\r
							<table align="center" bgcolor="#ffffff" cellpadding="0" cellspacing="0"\r
								   class="es-content-body"\r
								   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">\r
								<tr>\r
									<td align="left"\r
										style="padding:0;Margin:0;padding-top:20px;padding-right:20px;padding-left:20px">\r
										<table cellpadding="0" cellspacing="0"\r
											   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">\r
											<tr>\r
												<td align="left" style="padding:0;Margin:0;width:560px">\r
													<table cellpadding="0" cellspacing="0"\r
														   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"\r
														   width="100%">\r
														<tr>\r
															<td align="center"\r
																style="padding:0;Margin:0;display:none"></td>\r
														</tr>\r
													</table>\r
												</td>\r
											</tr>\r
										</table>\r
									</td>\r
								</tr>\r
							</table>\r
						</td>\r
					</tr>\r
				</table>\r
			</td>\r
		</tr>\r
	</table>\r
</div>\r
</body>\r
</html>`;
const licenseVerifiedTemplate = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN"\r
	"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">\r
<html lang="en" xmlns="http://www.w3.org/1999/xhtml">\r
<head>\r
	<meta charset="UTF-8">\r
	<meta content="width=device-width, initial-scale=1" name="viewport">\r
	<meta name="x-apple-disable-message-reformatting">\r
	<meta content="IE=edge" http-equiv="X-UA-Compatible">\r
	<meta content="telephone=no" name="format-detection">\r
	<title>New message</title><!--[if (mso 16)]>\r
	<style type="text/css">\r
		a {\r
			text-decoration: none;\r
		}\r
	</style>\r
	<![endif]--><!--[if gte mso 9]>\r
	<style>sup {\r
		font-size: 100% !important;\r
	}</style><![endif]--><!--[if gte mso 9]>\r
	<xml>\r
		<o:OfficeDocumentSettings>\r
			<o:AllowPNG></o:AllowPNG>\r
			<o:PixelsPerInch>96</o:PixelsPerInch>\r
		</o:OfficeDocumentSettings>\r
	</xml>\r
	<![endif]--><!--[if !mso]>-->\r
	<link href="https://fonts.googleapis.com/css?family=Roboto:400,400i,700,700i" rel="stylesheet"><!--<![endif]-->\r
	<style type="text/css">\r
        .rollover:hover .rollover-first {\r
            max-height: 0 !important;\r
            display: none !important;\r
        }\r
\r
        .rollover:hover .rollover-second {\r
            max-height: none !important;\r
            display: inline-block !important;\r
        }\r
\r
        .rollover div {\r
            font-size: 0px;\r
        }\r
\r
        u ~ div img + div > div {\r
            display: none;\r
        }\r
\r
        #outlook a {\r
            padding: 0;\r
        }\r
\r
        span.MsoHyperlink,\r
        span.MsoHyperlinkFollowed {\r
            color: inherit;\r
            mso-style-priority: 99;\r
        }\r
\r
        a.es-button {\r
            mso-style-priority: 100 !important;\r
            text-decoration: none !important;\r
        }\r
\r
        a[x-apple-data-detectors] {\r
            color: inherit !important;\r
            text-decoration: none !important;\r
            font-size: inherit !important;\r
            font-family: inherit !important;\r
            font-weight: inherit !important;\r
            line-height: inherit !important;\r
        }\r
\r
        .es-desk-hidden {\r
            display: none;\r
            float: left;\r
            overflow: hidden;\r
            width: 0;\r
            max-height: 0;\r
            line-height: 0;\r
            mso-hide: all;\r
        }\r
\r
        /*\r
	  .es-header-body a:hover {\r
		color:#2cb543!important;\r
		}\r
	  */\r
        /*\r
	  .es-content-body a:hover {\r
		color:#2cb543!important;\r
		}\r
	  */\r
        /*\r
	  .es-footer-body a:hover {\r
		color:#ffffff!important;\r
		}\r
	  */\r
        /*\r
	  .es-infoblock a:hover {\r
		color:#cccccc!important;\r
		}\r
	  */\r
        .es-button-border:hover {\r
            border-color: #42d159 #42d159 #42d159 #42d159 !important;\r
            background: #56d66b !important;\r
        }\r
\r
        .es-button-border:hover a.es-button,\r
        .es-button-border:hover button.es-button {\r
            background: #56d66b !important;\r
        }\r
\r
        @media only screen and (max-width: 600px) {\r
            .es-m-p35r {\r
                padding-right: 35px !important\r
            }\r
\r
            .es-m-p35l {\r
                padding-left: 35px !important\r
            }\r
\r
            *[class="gmail-fix"] {\r
                display: none !important\r
            }\r
\r
            p, a {\r
                line-height: 150% !important\r
            }\r
\r
            h1, h1 a {\r
                line-height: 120% !important\r
            }\r
\r
            h2, h2 a {\r
                line-height: 120% !important\r
            }\r
\r
            h3, h3 a {\r
                line-height: 120% !important\r
            }\r
\r
            h4, h4 a {\r
                line-height: 120% !important\r
            }\r
\r
            h5, h5 a {\r
                line-height: 120% !important\r
            }\r
\r
            h6, h6 a {\r
                line-height: 120% !important\r
            }\r
\r
            .es-header-body p {\r
            }\r
\r
            .es-content-body p {\r
            }\r
\r
            .es-footer-body p {\r
            }\r
\r
            .es-infoblock p {\r
            }\r
\r
            h1 {\r
                font-size: 30px !important;\r
                text-align: left\r
            }\r
\r
            h2 {\r
                font-size: 24px !important;\r
                text-align: left\r
            }\r
\r
            h3 {\r
                font-size: 20px !important;\r
                text-align: left\r
            }\r
\r
            h4 {\r
                font-size: 24px !important;\r
                text-align: left\r
            }\r
\r
            h5 {\r
                font-size: 20px !important;\r
                text-align: left\r
            }\r
\r
            h6 {\r
                font-size: 16px !important;\r
                text-align: left\r
            }\r
\r
            .es-header-body h1 a, .es-content-body h1 a, .es-footer-body h1 a {\r
                font-size: 30px !important\r
            }\r
\r
            .es-header-body h2 a, .es-content-body h2 a, .es-footer-body h2 a {\r
                font-size: 24px !important\r
            }\r
\r
            .es-header-body h3 a, .es-content-body h3 a, .es-footer-body h3 a {\r
                font-size: 20px !important\r
            }\r
\r
            .es-header-body h4 a, .es-content-body h4 a, .es-footer-body h4 a {\r
                font-size: 24px !important\r
            }\r
\r
            .es-header-body h5 a, .es-content-body h5 a, .es-footer-body h5 a {\r
                font-size: 20px !important\r
            }\r
\r
            .es-header-body h6 a, .es-content-body h6 a, .es-footer-body h6 a {\r
                font-size: 16px !important\r
            }\r
\r
            .es-menu td a {\r
                font-size: 14px !important\r
            }\r
\r
            .es-header-body p, .es-header-body a {\r
                font-size: 14px !important\r
            }\r
\r
            .es-content-body p, .es-content-body a {\r
                font-size: 14px !important\r
            }\r
\r
            .es-footer-body p, .es-footer-body a {\r
                font-size: 14px !important\r
            }\r
\r
            .es-infoblock p, .es-infoblock a {\r
                font-size: 12px !important\r
            }\r
\r
            .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3, .es-m-txt-c h4, .es-m-txt-c h5, .es-m-txt-c h6 {\r
                text-align: center !important\r
            }\r
\r
            .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3, .es-m-txt-r h4, .es-m-txt-r h5, .es-m-txt-r h6 {\r
                text-align: right !important\r
            }\r
\r
            .es-m-txt-j, .es-m-txt-j h1, .es-m-txt-j h2, .es-m-txt-j h3, .es-m-txt-j h4, .es-m-txt-j h5, .es-m-txt-j h6 {\r
                text-align: justify !important\r
            }\r
\r
            .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3, .es-m-txt-l h4, .es-m-txt-l h5, .es-m-txt-l h6 {\r
                text-align: left !important\r
            }\r
\r
            .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img, .es-m-txt-r .rollover:hover .rollover-second, .es-m-txt-c .rollover:hover .rollover-second, .es-m-txt-l .rollover:hover .rollover-second {\r
                display: inline !important\r
            }\r
\r
            .es-m-txt-r .rollover div, .es-m-txt-c .rollover div, .es-m-txt-l .rollover div {\r
                line-height: 0 !important;\r
                font-size: 0 !important\r
            }\r
\r
            .es-spacer {\r
                display: inline-table\r
            }\r
\r
            a.es-button, button.es-button {\r
                font-size: 18px !important\r
            }\r
\r
            .es-m-fw, .es-m-fw.es-fw, .es-m-fw .es-button {\r
                display: block !important\r
            }\r
\r
            .es-m-il, .es-m-il .es-button, .es-social, .es-social td, .es-menu {\r
                display: inline-block !important\r
            }\r
\r
            .es-adaptive table, .es-left, .es-right {\r
                width: 100% !important\r
            }\r
\r
            .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header {\r
                width: 100% !important;\r
                max-width: 600px !important\r
            }\r
\r
            .adapt-img:not([src*="default-img"]) {\r
                width: 100% !important;\r
                height: auto !important\r
            }\r
\r
            .es-mobile-hidden, .es-hidden {\r
                display: none !important\r
            }\r
\r
            .es-desk-hidden {\r
                width: auto !important;\r
                overflow: visible !important;\r
                float: none !important;\r
                max-height: inherit !important;\r
                line-height: inherit !important\r
            }\r
\r
            tr.es-desk-hidden {\r
                display: table-row !important\r
            }\r
\r
            table.es-desk-hidden {\r
                display: table !important\r
            }\r
\r
            td.es-desk-menu-hidden {\r
                display: table-cell !important\r
            }\r
\r
            .es-menu td {\r
                width: 1% !important\r
            }\r
\r
            table.es-table-not-adapt, .esd-block-html table {\r
                width: auto !important\r
            }\r
\r
            .es-social td {\r
                padding-bottom: 10px\r
            }\r
\r
            .es-text-3309, .es-text-3309 p, .es-text-3309 a, .es-text-3309 h1, .es-text-3309 h2, .es-text-3309 h3, .es-text-3309 h4, .es-text-3309 h5, .es-text-3309 h6, .es-text-3309 ul, .es-text-3309 ol {\r
                font-size: 20px !important\r
            }\r
\r
            a.es-button, button.es-button {\r
                display: inline-block !important\r
            }\r
\r
            .es-button-border {\r
                display: inline-block !important\r
            }\r
        }\r
	</style>\r
</head>\r
<body style="width:100%;height:100%;padding:0;Margin:0">\r
<div class="es-wrapper-color" style="background-color:#FFFFFF"><!--[if gte mso 9]>\r
	<v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">\r
		<v:fill type="tile" color="#FFFFFF"></v:fill>\r
	</v:background>\r
	<![endif]-->\r
	<table cellpadding="0" cellspacing="0" class="es-wrapper"\r
		   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top;background-color:#FFFFFF"\r
		   width="100%">\r
		<tr>\r
			<td style="padding:0;Margin:0" valign="top">\r
				<table align="center" cellpadding="0" cellspacing="0" class="es-content"\r
					   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:100%;table-layout:fixed !important">\r
					<tr>\r
						<td align="center" bgcolor="transparent" style="padding:0;Margin:0">\r
							<table align="center" bgcolor="#ffffff" cellpadding="0" cellspacing="0"\r
								   class="es-content-body"\r
								   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">\r
								<tr>\r
									<td align="left"\r
										style="padding:0;Margin:0;padding-top:20px;padding-right:20px;padding-left:20px">\r
										<table cellpadding="0" cellspacing="0"\r
											   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">\r
											<tr>\r
												<td align="left" style="padding:0;Margin:0;width:560px">\r
													<table cellpadding="0" cellspacing="0" role="presentation"\r
														   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"\r
														   width="100%">\r
														<tr>\r
															<td align="center"\r
																style="padding:0;Margin:0;padding-top:5px;padding-bottom:10px;font-size:0">\r
																<img\r
																	alt=""\r
																	src="https://glimmr.app/images/icon.png"\r
																	style="display:block;font-size:14px;border:0;outline:none;text-decoration:none;border-radius:50px"\r
																	width="100">\r
															</td>\r
														</tr>\r
														<tr>\r
															<td align="center"\r
																style="padding:20px;Margin:0;font-size:0">\r
																<table border="0" cellpadding="0" cellspacing="0"\r
																	   class="es-spacer" height="100%"\r
																	   role="presentation"\r
																	   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"\r
																	   width="100%">\r
																	<tr>\r
																		<td\r
																			style="padding:0;Margin:0;border-bottom:1px solid #cccccc;background:none;height:1px;width:100%;margin:0px"></td>\r
																	</tr>\r
																</table>\r
															</td>\r
														</tr>\r
													</table>\r
												</td>\r
											</tr>\r
										</table>\r
									</td>\r
								</tr>\r
							</table>\r
						</td>\r
					</tr>\r
				</table>\r
				<table align="center" cellpadding="0" cellspacing="0" class="es-content"\r
					   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:100%;table-layout:fixed !important">\r
					<tr>\r
						<td align="center" bgcolor="transparent" style="padding:0;Margin:0">\r
							<table align="center" bgcolor="#ffffff" cellpadding="0" cellspacing="0"\r
								   class="es-content-body"\r
								   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">\r
								<tr>\r
									<td align="left"\r
										style="padding:0;Margin:0;padding-top:20px;padding-right:20px;padding-left:20px">\r
										<table cellpadding="0" cellspacing="0"\r
											   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">\r
											<tr>\r
												<td align="left" style="padding:0;Margin:0;width:560px">\r
													<table cellpadding="0" cellspacing="0" role="presentation"\r
														   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"\r
														   width="100%">\r
														<tr>\r
															<td align="center" class="es-m-txt-c"\r
																style="padding:0;Margin:0"><h2\r
																style="Margin:0;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;mso-line-height-rule:exactly;letter-spacing:0;font-size:24px;font-style:normal;font-weight:normal;line-height:29px;color:#333333">\r
																<strong>License Verified</strong></h2></td>\r
														</tr>\r
													</table>\r
												</td>\r
											</tr>\r
											<tr>\r
												<td align="left" style="padding:0;Margin:0;width:560px">\r
													<table cellpadding="0" cellspacing="0" role="presentation"\r
														   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"\r
														   width="100%">\r
														<tr>\r
															<td align="center" class="es-text-3309 es-m-txt-c"\r
																style="padding:0;Margin:0;padding-top:5px;font-size:20px">\r
																<p\r
																	style="Margin:0;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:34px !important;letter-spacing:0;color:#666666;font-size:20px">\r
																	Thank you for validating your license! You're all\r
																	set. Please note that you can use your license on\r
																	multiple devices. All you need to do is repeat the\r
																	in-app\r
																	activation process on any new device.</p></td>\r
														</tr>\r
													</table>\r
												</td>\r
											</tr>\r
										</table>\r
									</td>\r
								</tr>\r
							</table>\r
						</td>\r
					</tr>\r
				</table>\r
				<table align="center" cellpadding="0" cellspacing="0" class="es-content"\r
					   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:100%;table-layout:fixed !important">\r
					<tr>\r
						<td align="center" bgcolor="transparent" style="padding:0;Margin:0">\r
							<table align="center" bgcolor="#ffffff" cellpadding="0" cellspacing="0"\r
								   class="es-content-body"\r
								   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">\r
								<tr>\r
									<td align="left"\r
										style="padding:0;Margin:0;padding-top:20px;padding-right:20px;padding-left:20px">\r
										<table cellpadding="0" cellspacing="0"\r
											   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">\r
											<tr>\r
												<td align="left" style="padding:0;Margin:0;width:560px">\r
													<table cellpadding="0" cellspacing="0" role="presentation"\r
														   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"\r
														   width="100%">\r
														<tr>\r
															<td align="center" class="es-m-txt-c"\r
																style="padding:0;Margin:0"><p\r
																style="Margin:0;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;letter-spacing:0;color:#333333;font-size:14px">\r
																Questions? Email us at <a\r
																href="mailto:support@glimmr.app"\r
																style="mso-line-height-rule:exactly;text-decoration:underline;color:#19bcc2;font-size:14px">support@glimmr.app</a>\r
															</p></td>\r
														</tr>\r
													</table>\r
												</td>\r
											</tr>\r
										</table>\r
									</td>\r
								</tr>\r
							</table>\r
						</td>\r
					</tr>\r
				</table>\r
				<table align="center" cellpadding="0" cellspacing="0" class="es-content"\r
					   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:100%;table-layout:fixed !important">\r
					<tr>\r
						<td align="center" bgcolor="transparent" style="padding:0;Margin:0">\r
							<table align="center" bgcolor="#ffffff" cellpadding="0" cellspacing="0"\r
								   class="es-content-body"\r
								   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">\r
								<tr>\r
									<td align="left"\r
										style="padding:0;Margin:0;padding-top:20px;padding-right:20px;padding-left:20px">\r
										<table cellpadding="0" cellspacing="0"\r
											   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">\r
											<tr>\r
												<td align="left" style="padding:0;Margin:0;width:560px">\r
													<table cellpadding="0" cellspacing="0"\r
														   style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"\r
														   width="100%">\r
														<tr>\r
															<td align="center"\r
																style="padding:0;Margin:0;display:none"></td>\r
														</tr>\r
													</table>\r
												</td>\r
											</tr>\r
										</table>\r
									</td>\r
								</tr>\r
							</table>\r
						</td>\r
					</tr>\r
				</table>\r
			</td>\r
		</tr>\r
	</table>\r
</div>\r
</body>\r
</html>`;
const config = {
  host: SMTP_HOST,
  port: Number(SMTP_PORT),
  auth: {
    user: SMTP_USER,
    pass: SMTP_PASSWORD
  },
  secure: true,
  logger: true,
  debug: true
};
const getEmailVerificationConfig = (email, code) => ({
  from: SMTP_FROM,
  to: email,
  subject: "Your single-use code",
  html: emailVerificationTemplate.replace("[CODE]", code),
  headers: {
    "X-Face": PUBLIC_ICON_URL,
    "X-Image-URL": PUBLIC_ICON_URL
  }
});
const getLicenseVerifiedConfig = (email) => ({
  from: SMTP_FROM,
  to: email,
  bcc: "glimmr.app+98972a7044@invite.trustpilot.com",
  subject: "License verified",
  html: licenseVerifiedTemplate,
  headers: {
    "X-Face": PUBLIC_ICON_URL,
    "X-Image-URL": PUBLIC_ICON_URL
  }
});
const getBugReportConfig = (title, description, machine) => {
  const data = {
    description,
    machine
  };
  const finalTitle = title ?? "Untitled";
  const subject = `[BUG REPORT] : ${finalTitle}`;
  const text = JSON.stringify(data);
  return {
    from: SMTP_FROM,
    to: SMTP_USER,
    subject,
    text
  };
};
const sendMail = async (options) => {
  const transporter = nodemailer.createTransport(config);
  await transporter.sendMail(options);
};
const sendLicenseVerifiedEmail = async (email) => {
  return sendMail(getLicenseVerifiedConfig(email));
};
const sendEmailVerification = async (email, code) => {
  return sendMail(getEmailVerificationConfig(email, code));
};
const sendBugReport = async (title, description, machine) => {
  const options = getBugReportConfig(title, description, machine);
  return sendMail(options);
};
export {
  sendEmailVerification as a,
  sendLicenseVerifiedEmail as b,
  sendBugReport as s
};
